import { render, staticRenderFns } from "./NavbarMobile.vue?vue&type=template&id=64d40b8a&scoped=true"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"
import style0 from "./NavbarMobile.vue?vue&type=style&index=0&id=64d40b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d40b8a",
  null
  
)

export default component.exports